import React from 'react';
import './styles.scss';
import { Spinner } from 'react-bootstrap';
import Button from '../../../../components/molecules/buttons';
import {
  ArrowLeft,
  Delete,
  Discount,
  Pencil,
} from '../../../../components/atoms/icons';
import useIdPartner from './hooks';
import { firstLetterCapitalized } from '../../../../components/atoms/func';
import { successUpdateMsg } from '../../../../components/atoms/const';
import Modal from '../../../../components/organisms/modals';
import RenderTablePartner from './RenderTablePartner';
import RenderTableContactPerson from './RenderTableContactPerson';
import RenderTableCommission from './RenderTableCommission';
import RenderTableClientCommission from './RenderTableClientCommission';

function DetailPartner() {
  const {
    navigate, partnerById, modalPartner, modalContactPerson, modalDatePicker, modalClientCommission,
    handleChangeStartDate, handleChangeEndDate, selectedDate, monthlyCommission, partnerCommissions,
    paymentModal, formik,
  } = useIdPartner();

  const renderModalBody:string = React.useMemo(() => {
    if (!modalPartner.result) return 'Are you sure? Do you want to delete this partner';
    return successUpdateMsg.SUCCESS_DELETE_PARTNER_MSG;
  }, [modalPartner.result]);

  const renderSpinnerText = (result: string | undefined, fail: string, condition: boolean) => {
    if (partnerById.isLoading) return <Spinner animation="border" size="sm" />;
    if (condition) return result;
    return fail;
  };

  const widthHandler = React.useMemo(() => ({ minWidth: '30px', maxWidth: '30px', width: '30px' }), []);

  return (
    <div className="p-4 px-xl-5">
      <div
        className="d-flex justify-content-between"
        style={{ marginBottom: '35px' }}
      >
        <div className="d-flex align-items-start">
          <button
            onClick={navigate.landing}
            type="button"
            className="border-0 bg-transparent"
            style={{ marginTop: '8px' }}
          >
            <ArrowLeft />
          </button>
          <div className="ms-3">
            <h4 className="fw-bold mt-2 mb-3">
              {renderSpinnerText(firstLetterCapitalized(partnerById.data?.name), '-', !!partnerById.data?.name)}
            </h4>
            <div className="d-flex align-items-center justify-content-start fz-14">
              <div style={{ marginTop: '-2px' }}><Discount width={23} /></div>
              <div className="ms-2">{renderSpinnerText(`$${partnerById.data?.comission?.toString()}`, '0', !!partnerById.data?.comission)}</div>
            </div>
          </div>
        </div>
        <div className="d-flex mt-1">
          <div className="me-3">
            <Button.CircleIcon
              id="editRoute"
              icon={<Pencil width={16} color="white" />}
              type="button"
              onClick={navigate.editPartnerDetail}
              isButton
            />
          </div>
          <Modal.Default
            cancelLabel="No"
            submitLabel="Yes"
            title="Delete Partner"
            body={renderModalBody}
            onSubmit={modalPartner.handleDelete}
            isLoading={modalPartner.isLoading}
            result={modalPartner.result}
            onAfterResult={modalPartner.onAfterDelete}
          >
            <Button.CircleIcon id="circleDeleteRoute" icon={<Delete width={15} color="white" />} />
          </Modal.Default>
        </div>
      </div>
      <RenderTablePartner
        partnerById={partnerById.data}
        isLoading={partnerById.isLoading}
        onNavigateToEdit={navigate.editPartner}
        modal={modalPartner}
        renderModalBody={renderModalBody}
        widthHandler={widthHandler}
      />
      <RenderTableContactPerson
        contactPerson={partnerById.data?.contactPerson?.filter((contact) => contact.deleted === 0)}
        modal={modalContactPerson}
        isLoading={partnerById.isLoading}
        onNavigateToEdit={navigate.editContactPerson}
        widthHandler={widthHandler}
      />
      <RenderTableCommission
        partnerById={partnerById.data}
        partnerCommissions={partnerCommissions.data}
        modal={modalDatePicker}
        paymentModal={paymentModal}
        formik={formik}
        isLoading={partnerCommissions.isLoading}
        widthHandler={widthHandler}
        handleChangeStartDate={handleChangeStartDate}
        handleChangeEndDate={handleChangeEndDate}
        selectedDate={selectedDate}
      />
      <RenderTableClientCommission
        partnerById={partnerById.data}
        monthlyCommission={monthlyCommission.data}
        modal={modalClientCommission}
        isLoading={partnerById.isLoading}
        widthHandler={widthHandler}
      />
    </div>
  );
}

export default DetailPartner;
